import type { EstadoRespuesta, EventoResumen } from '../../api/tipos';
import { COLOR_POR_DEFECTO } from '../../lib/personas';
import { diaYMes, lineaCorta, textoCierre, textoConfirmados } from '../../lib/fechas';

const ESTADOS: Record<EstadoRespuesta, { texto: string; clases: string }> = {
  ASISTE: { texto: 'Confirmaste', clases: 'text-lima border-lima/40 bg-lima/10' },
  NO_ASISTE: { texto: 'No asistís', clases: 'text-tenue border-tenue/30 bg-tenue/[.07]' },
  SIN_RESPONDER: { texto: 'Sin responder', clases: 'text-ambar border-ambar/40 bg-ambar/10' },
};

interface Props {
  evento: EventoResumen;
  seleccionado: boolean;
  onSeleccionar: () => void;
}

export function TarjetaEvento({ evento, seleccionado, onSeleccionar }: Props) {
  const { dia, mes } = diaYMes(evento.fechaLocal);
  const estado = ESTADOS[evento.miEstado];
  const color = evento.tipo?.color ?? COLOR_POR_DEFECTO;

  return (
    <div
      className={`flex overflow-hidden rounded-tarjeta border bg-panel transition-shadow ${
        seleccionado
          ? 'border-lima/50 shadow-[0_0_0_1px_rgba(161,198,35,.16)]'
          : 'border-white/[.09] hover:border-white/20'
      }`}
    >
      <div className="w-1 flex-none" style={{ background: color }} />

      <button
        type="button"
        // Solo elige el evento; el formulario se abre con «Responder asistencia».
        onClick={onSeleccionar}
        aria-pressed={seleccionado}
        className="flex min-w-0 flex-1 items-center gap-3 px-3 py-3 text-left"
      >
        <div className="w-[46px] flex-none rounded-[9px] bg-white/5 py-1.5 text-center">
          <div className="font-titulo text-[18px] font-extrabold leading-none">{dia}</div>
          <div className="mt-0.5 text-[9px] uppercase tracking-[1.2px] text-debil">{mes}</div>
        </div>

        <div className="min-w-0 flex-1">
          <div className="truncate font-titulo text-[14.5px] font-bold">{evento.titulo}</div>
          <div className="mt-1 truncate text-[11.5px] text-debil">
            {lineaCorta(evento.fechaLocal, evento.horaLocal)} · {textoConfirmados(evento.confirmados)}
          </div>

          <div className="mt-1.5 flex flex-wrap items-center gap-1.5">
            <span
              className={`inline-block rounded-full border px-2.5 py-[3px] text-[10.5px] font-semibold ${estado.clases}`}
            >
              {estado.texto}
            </span>
            {evento.cerrado ? (
              <span className="inline-block rounded-full border border-coral/35 bg-coral/10 px-2.5 py-[3px] text-[10.5px] font-semibold text-coral">
                Cerrado
              </span>
            ) : (
              evento.cierreLocal && (
                <span className="text-[10.5px] text-mudo">
                  {textoCierre(evento.cierreLocal, evento.cierreHoraLocal)}
                </span>
              )
            )}
          </div>
        </div>
      </button>
    </div>
  );
}
